<template>
    <div class="buy-overview">
        <!-- <el-header style="height: 4%; display: flex;justify-content: space-between;box-sizing: border-box;">
                <div style="display: flex;gap:10px;width: 320px;">
                    <img src="../assets/favicon.png" alt="">
                    <div class="header-text-left">凌丰供应商系统</div>
                    <div class="pe-header-text">采购订单（明细）</div>
                </div>

                <div style="width: 320px;">
                    <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                    <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
                </div>
            </el-header> -->

        <el-header class="overview-header">
            <div class="header-left">
                <img src="@/assets/favicon.png" alt="" />
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">采购订单（明细）</div>
            </div>
            <div class="header-info">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }})</div>
                <div class="header-right">{{ homeDate }}</div>
            </div>
        </el-header>

        <!-- main -->
        <el-main style="height: 94%;padding: 0;box-sizing: border-box;display: flex;flex-direction: column;">
            <div class="toolbar">
                <el-button v-if="roleName == '管理员'" icon="el-icon-sort-down" plain size="small" @click="pull_reflesh">拉取</el-button>
                <el-button icon="el-icon-refresh" plain size="small" @click="senior_search">刷新</el-button>
                <el-popover :width="450" trigger="click">
                    <template #reference>
                        <el-button icon="el-icon-menu" plain size="small">状态筛选</el-button>
                    </template>
                    <template #default>
                        <div>
                            <el-radio-group v-model="radio1" size="mini" @change="radio_change">
                                <el-radio-button label="全部"></el-radio-button>
                                <el-radio-button label="未发货"></el-radio-button>
                                <el-radio-button label="部分发货"></el-radio-button>
                                <el-radio-button label="在途"></el-radio-button>
                                <el-radio-button label="部分签收"></el-radio-button>
                                <el-radio-button label="签收完成"></el-radio-button>
                            </el-radio-group>
                        </div>
                    </template>
                </el-popover>
                <el-popover :width="530" trigger="click">
                    <template #reference>
                        <el-button icon="el-icon-search" plain size="small">高级搜索</el-button>
                    </template>
                    <template #default>
                        <div>
                            <el-form label-width="100px">
                                <el-form-item label="订单编号">
                                    <el-input style="width: 400px;font-size: 14px;" v-model="searchobj.formId" clearable placeholder="请输入订单编号" size="mini" @clear="clearFormId">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="需用日期范围">
                                    <el-date-picker v-model="useDate" type="datetimerange" align="right" style="font-size: 14px;" @change="usedate_change" start-placeholder="开始日期"
                                        end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd" size="mini">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="合同号">
                                    <el-select style="width: 300px;font-size: 14px;" size="mini" clearable v-model="searchobj.projectId" filterable placeholder="选择合同号"
                                        default-first-option remote :remote-method="async_projectId" :loading="loading2">
                                        <el-option v-for="item in project_options" :key="item.id" :label="item.trackNumber" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="单价范围">
                                    <div>
                                        <el-input-number v-model="searchobj.startPrice" :min="0" placeholder="0" size="mini" clearable style="font-size: 14px;" :controls="false">
                                        </el-input-number>
                                        <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                                        <el-input-number v-model="searchobj.endPrice" :min="1" placeholder="99999" size="mini" clearable style="font-size: 14px;" :controls="false">
                                        </el-input-number>
                                    </div>
                                </el-form-item>
                                <el-form-item label="物料">
                                    <el-select style="width: 400px;font-size: 14px;" size="mini" clearable filterable remote value-key="materialId" v-model="searchobj.materialId"
                                        placeholder="请输入物料名称、型号、编码" :remote-method="async_material" :loading="loading2" default-first-option>
                                        <el-option v-for="item in material_options" :key="item.materialId" style="width: 450px;"
                                            :label="(roleName != '供应商' || roleName == '供应商' && item.nameAlias.length == 0) ? (item.materialName + '--' + item.materialType) : (item.nameAlias.join('--'))"
                                            :value="item.materialId">
                                            <template>
                                                <div style="display: flex;gap:10px">
                                                    <div style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.materialName }}</div>
                                                    <div style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.materialType }}</div>
                                                </div>
                                            </template>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="供应商" v-if="roleName != '供应商'">
                                    <el-select style="width: 300px;font-size: 14px;" size="mini" clearable filterable value-key="id" v-model="searchobj.supplierId"
                                        placeholder="选择供应商" remote :remote-method="async_supplier" :loading="loading2" default-first-option>
                                        <el-option v-for="item in supplier_options" :key="item.id" :label="item.supplierName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <div style="text-align: right;">
                                <el-button type="success" @click="goto_search" size="mini">搜索</el-button>
                            </div>
                        </div>
                    </template>
                </el-popover>
                <el-button icon="el-icon-truck" type="primary" size="small" @click="per_gen">发货</el-button>
                <el-button icon="el-icon-s-release" plain size="small" @click="clear_selection">清空选择</el-button>
                <el-button icon="el-icon-document" plain size="small" @click="goto_sendPage">查看送货单</el-button>
                <el-button icon="el-icon-download" plain size="small" @click="expExcel">导出</el-button>
                <el-button icon="el-icon-switch-button" type="danger" size="small" @click="logback">退出登录</el-button>
            </div>
            <div class="table-body">
                <el-table ref="multipleTable" :data="table_data" border height="100%" :header-row-style="{ height: '0' }"
                    :header-cell-style="{ background: '#fff', color: '#000', padding: '0', textAlign: 'center' }" :row-style="{ height: '0' }" :cell-style="{ padding: '2px 0' }"
                    :row-class-name="rowClassName" @selection-change="handleSelectionChange" row-key="id" v-loading="table_loading" @cell-dblclick="gen_doubleclick"
                    @row-click="handleRowClick">
                    <el-table-column type="selection" width="40" :reserve-selection="true" :selectable="select_function"></el-table-column>
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="{ $index }">
                            <span>{{ $index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单号" prop="formId" width="195" align="center" sortable></el-table-column>
                    <el-table-column label="跟踪号" prop="projectName" width="220" align="center" sortable></el-table-column>
                    <el-table-column label="合同号" prop="trackNumber" width="200" align="center" sortable></el-table-column>
                    <!-- <el-table-column label="合同号" prop="contractId" width="220" align="center" sortable></el-table-column> -->
                    <el-table-column label="需用日期" prop="useDate" width="110" align="center" sortable></el-table-column>
                    <el-table-column label="状态" prop="statusName" width="95" align="center" sortable>
                        <template slot-scope="scope">
                            <el-tag :type="status_color(scope.row)" size="mini" style="font-size: 14px;">{{ scope.row.statusName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="供应商" v-if="roleName != '供应商'" prop="supplier" width="240" align="center" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column label="物料名称" v-if="roleName != '供应商'" prop="materialName" width="180" align="center" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column label="物料类型" v-if="roleName != '供应商'" prop="materialType" width="180" align="center" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column label="品名规格" prop="nameAlias" width="350" align="left" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select v-if="scope.row.alias_show" v-model="select_alias" value-key="id" clearable filterable style="width: 100%;" allow-create default-first-option
                                placeholder="请选择别称" @change="change_blur(scope.row, scope.column)" @blur="alias_blur(scope.row, scope.column)" v-focus size="mini">
                                <el-option v-for="item in scope.row.nameAlias" :key="item.id" :label="item.name" :value="item">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.useAliasId && scope.row.nameAlias.length ? (scope.row.nameAlias.find(item => item.id == scope.row.useAliasId)).name :
                                  scope.row.materialName + '--' + scope.row.materialType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料编码" prop="materialBarcode" width="110" align="center" sortable></el-table-column>
                    <el-table-column label="送货地址" prop="deliveryAddress" width="200" align="left" sortable show-overflow-tooltip />
                    <el-table-column label="备注" prop="itemRemark" width="200" align="left" sortable show-overflow-tooltip />
                    <el-table-column label="单位" prop="unit" width="75" align="center" sortable></el-table-column>
                    <el-table-column label="单价" prop="price" width="100" align="center" sortable></el-table-column>
                    <el-table-column label="金额" prop="totalPrice" width="100" align="center" sortable></el-table-column>
                    <el-table-column label="数量" prop="buyNumber" width="75" align="center" sortable></el-table-column>
                    <el-table-column label="已发货" prop="outputNumber" width="90" align="center" sortable></el-table-column>
                    <el-table-column label="签收" prop="receiveNumber" width="75" align="center" sortable></el-table-column>
                </el-table>
            </div>
            <div class="table-footer">
                <el-pagination background layout="sizes, prev, pager, next" :total="totalPage" @size-change="handleSizeChange" @current-change="change_data"
                    :current-page="searchobj.currentPage" :page-size="searchobj.pageSize" :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
                </el-pagination>
            </div>
        </el-main>

        <!-- 发货预览 -->
        <el-dialog title="发货预览" :visible.sync="gen_visiable" width="75%" top="5vh" class="dialog-height">
            <div class="gen_data">
                <el-table :data="multipleSelection" :header-row-style="{ height: '0' }" ref="genTable" :header-cell-style="{ background: '#fff', color: '#000', padding: '0' }"
                    :row-style="{ height: '0' }" :cell-style="{ padding: '2px 0' }" border show-summary>
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="{ $index }">
                            <span>{{ $index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="跟踪号" prop="projectName" width="220" align="center" sortable></el-table-column> -->
                    <el-table-column label="合同号" prop="trackNumber" width="200" align="center" sortable></el-table-column>
                    <el-table-column label="状态" prop="status_list[scope.row.status]" width="95" align="center" sortable>
                        <template slot-scope="scope">
                            <el-tag :type="status_color(scope.row)" size="mini" style="font-size: 14px;">{{
                  scope.row.statusName }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="品名规格" prop="nameAlias" width="auto" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.useAliasId && scope.row.nameAlias.length ? (scope.row.nameAlias.find(item => item.id
                  ==
                  scope.row.useAliasId)).name : scope.row.materialName + '--' + scope.row.materialType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="物料编码" prop="materialBarcode" width="110" align="center" sortable></el-table-column>
                    <el-table-column label="单位" prop="unit" width="75" align="center" sortable></el-table-column>
                    <el-table-column label="单价" prop="price" width="100" align="center" sortable></el-table-column>
                    <el-table-column label="金额" prop="gen_totalprice" width="100" align="center" sortable></el-table-column>
                    <el-table-column label="数量" prop="buyNumber" width="75" align="center" sortable></el-table-column>
                    <el-table-column label="已发货" prop="outputNumber" width="90" align="center" sortable></el-table-column>
                    <el-table-column label="新增发货" prop="gen_num" width="150" align="center" sortable>
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.gen_num" :min="0" :max="scope.row.buyNumber - scope.row.outputNumber" style="width:100%;" size="mini"
                                @change="count_totalprice(scope.row)">
                            </el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60">
                        <template slot-scope="scope">
                            <el-button type="danger" plain circle size="mini" icon="el-icon-close" @click="item_close(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="success" @click="fill_gennum" size="small">填充数量</el-button>
                <el-button @click="gen_visiable = false" size="small">取 消</el-button>
                <el-button type="success" @click="gen_send" size="small">发 货</el-button>
            </div>
        </el-dialog>

        <!-- <el-dialog title="添加品名规格" :visible.sync="addname_visiable" width="50%" top="5vh" class="dialog-height">
      </el-dialog> -->

        <!-- footer -->
        <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>
    </div>
</template>

<script>
import { exportExcel2 } from "@/utils/utils";
import { get_project, get_supplier, get_material } from "@/utils/func";
import * as buyPageApi from "@/Api/buyPageApi";
export default {
    name: "buyPage",
    components: {},
    data() {
        return {
            homeDate: "",
            userNme: sessionStorage.getItem("userName"),
            radio1: "全部",
            searchobj: {
                formId: "",
                projectId: "",
                pageSize: 100,
                currentPage: 1,
            },
            gettable_params: {
                pageSize: 30,
                currentPage: 1,
                keyword: "",
            },
            header: {
                headers: { token: sessionStorage.getItem("token") },
            },
            table_data: [],
            table_loading: false,
            multipleSelection: [],
            totalPage: 30,
            useDate: "",
            loading2: false,
            project_options: [],
            contract_options: [],
            material_options: [],
            supplier_options: [],
            gen_visiable: false,
            addname_visiable: false,
            status_list: ["未发货", "部分发货", "在途", "部分签收", "签收完成"],
            select_alias: "",
            roleName: sessionStorage.getItem("roleName"),
            flag: false,
        };
    },
    computed: {},
    methods: {
        //显示时间
        showTime() {
            setTimeout(() => {
                this.showTime();
            }, 1000);
            this.homeDate = this.$getTime();
        },
        //退出
        logback() {
            this.$confirm("退出登录", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    console.log("**********退出**********");
                    sessionStorage.clear();
                    this.$router.push("/login");
                })
                .catch(() => {});
        },
        /////////////////////////////////////////////////
        rowClassName({ row }) {
            // console.log('rowClassName');
            const boll = this.multipleSelection.some((obj) => obj.id == row.id);
            if (boll) return "selected-row";
        },
        ////////////////////////////////////////////////
        //改变勾选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            // this.multipleSelection.push(val[val.length-1])
        },
        // 点击行切换勾选（复选框列由组件自身处理，避免重复切换）
        handleRowClick(row, column) {
            if (column.type === "selection") return;
            if (!this.select_function(row)) return;
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        //页码发生变化时
        change_data(e) {
            this.searchobj.currentPage = e;
            this.senior_search();
        },
        //修改每页大小
        handleSizeChange(e) {
            this.searchobj.pageSize = e;
            this.searchobj.currentPage = 1;
            this.senior_search();
        },
        //状态颜色
        status_color(row) {
            if (row.statusName == "未发货") return "info";
            else if (row.statusName == "部分发货") return "warning";
            else if (row.statusName == "在途" || row.statusName == "部分签收") return "";
            else if (row.statusName == "签收完成") return "success";
        },
        goto_sendPage() {
            const { href } = this.$router.resolve({
                path: "/sendPage",
            });
            window.open(href, "_blank");
        },
        test() {
            this.table_data = [];
        },
        clear_selection() {
            this.$confirm("清空所有勾选吗？", "提示", {
                confirmButtonText: "清空",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$refs.multipleTable.clearSelection();
                })
                .catch(() => {});
        },
        clearFormId() {
            this.$set(this.searchobj, "formId", "");
        },
        usedate_change() {
            console.log(this.useDate);
            if (this.useDate) {
                this.searchobj.startUseDate = this.useDate[0];
                this.searchobj.endUseDate = this.useDate[1];
            } else {
                this.searchobj.startUseDate = "";
                this.searchobj.endUseDate = "";
            }
        },
        async_projectId(query) {
            get_project(this, query);
        },
        async_material(query) {
            get_material(this, query);
        },
        async_supplier(query) {
            get_supplier(this, query);
        },
        per_gen() {
            if (this.multipleSelection.length == 0) {
                this.$alert("请先勾选选项", "警告");
                return;
            }

            let temAddress = this.multipleSelection.find((item) => item.deliveryAddress != null);
            if (temAddress && this.multipleSelection.some((item) => item.deliveryAddress != temAddress.deliveryAddress && item.deliveryAddress != null)) {
                this.$confirm("送货地址不唯一，是否继续生成送货单？", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        for (let item of this.multipleSelection) {
                            if (item.statusName != "未发货" && item.statusName != "部分发货") {
                                this.$message({ type: "warning", message: "请勾选未发货或部分发货的选项" });
                                return;
                            }
                        }
                        this.gen_visiable = true;
                    })
                    .catch(() => {});
            } else {
                for (let item of this.multipleSelection) {
                    if (item.statusName != "未发货" && item.statusName != "部分发货") {
                        this.$message({ type: "warning", message: "请勾选未发货或部分发货的选项" });
                        return;
                    }
                }
                this.gen_visiable = true;
            }
        },
        select_function(row) {
            if (row.statusName != "未发货" && row.statusName != "部分发货") return false;
            return true;
        },
        count_totalprice(row) {
            row.gen_totalprice = (row.price * row.gen_num).toFixed(2);
        },
        // 预览页剔除项
        item_close(index, row) {
            this.$refs.multipleTable.selection.forEach((item) => {
                if (item.id == row.id) {
                    this.$refs.multipleTable.toggleRowSelection(item);
                    console.log(item, row);
                }
            });
        },
        fill_gennum() {
            this.multipleSelection.forEach((item) => {
                item.gen_num = item.buyNumber - item.outputNumber;
                item.gen_totalprice = (item.price * item.gen_num).toFixed(2);
            });
        },

        // 生成送货单
        gen_send() {
            if (this.multipleSelection.length == 0) {
                this.$alert("请先勾选单据项", "警告");
                return;
            }
            if (this.multipleSelection.some((item) => item.gen_num == 0)) {
                this.$alert("存在发货数量为0的项", "警告");
                return;
            }
            this.$confirm("确定生成送货单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    let send_list = this.multipleSelection.map((item, index) => {
                        return {
                            index: index + 1,
                            purchaseId: item.id,
                            projectId: item.projectId,
                            useDate: item.useDate,
                            supplierId: item.supplierId,
                            materialId: item.materialId,
                            outputNumber: item.gen_num,
                        };
                    });
                    buyPageApi
                        .addSentFormApi(send_list, this)
                        .then((res) => {
                            this.$refs.multipleTable.clearSelection();
                            this.$message({ type: "success", message: "生成成功" });
                            this.gen_visiable = false;
                            this.senior_search();
                            const { href } = this.$router.resolve({
                                path: "/sendPage_detail",
                                query: {
                                    check_list: res,
                                    check_status: 1,
                                },
                            });
                            window.open(href, "_blank");
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },

        goto_search() {
            this.searchobj.currentPage = 1;
            this.senior_search();
        },
        radio_change() {
            console.log(this.radio1);
            if (this.radio1 == "全部") {
                this.searchobj.status = "";
            } else if (this.radio1 == "未发货") {
                this.searchobj.status = 0;
            } else if (this.radio1 == "部分发货") {
                this.searchobj.status = 1;
            } else if (this.radio1 == "在途") {
                this.searchobj.status = 2;
            } else if (this.radio1 == "部分签收") {
                this.searchobj.status = 3;
            } else if (this.radio1 == "签收完成") {
                this.searchobj.status = 4;
            }
            this.searchobj.currentPage = 1;
            this.senior_search();
        },
        senior_search() {
            this.table_loading = true;
            buyPageApi
                .purchaseFormQuery(this.searchobj, this)
                .then((res) => {
                    this.table_data = res.records.map((item) => {
                        return {
                            ...item,
                            gen_num: 0,
                            gen_totalprice: 0,
                            receiveNumber: item.receiveNumber == null ? 0 : item.receiveNumber,
                            statusName: this.getStatusName(item),
                            alias_show: false,
                        };
                    });
                    this.totalPage = res.total;
                })
                .catch(() => {})
                .finally(() => {
                    this.table_loading = false;
                });
        },
        getStatusName(item) {
            if (item.outputNumber == 0) return "未发货";
            else if (item.outputNumber > 0 && item.outputNumber < item.buyNumber) return "部分发货";
            else if (item.receiveNumber == 0 && item.outputNumber == item.buyNumber) return "在途";
            else if (item.receiveNumber > 0 && item.receiveNumber < item.buyNumber && item.outputNumber == item.buyNumber) return "部分签收";
            else if (item.receiveNumber == item.buyNumber) return "签收完成";
            return "";
        },
        gen_doubleclick(row, column) {
            console.log(column.property);
            if (column.property == "nameAlias") {
                row.alias_show = true;
            }
        },
        change_blur(row, column) {
            if (column.property == "nameAlias") {
                row.alias_show = false;
                console.log(this.select_alias);
                if (typeof this.select_alias === "string") {
                    if (this.select_alias.trim() == "") return;
                    else {
                        ///////添加别名//////////
                        let addname_obj = new Object();
                        addname_obj.id = row.id;
                        addname_obj.materialId = row.materialId;
                        addname_obj.supplierId = row.supplierId;
                        addname_obj.nameAlias = [this.select_alias.trim()];
                        console.log("发送更新别名数据：", addname_obj);
                        buyPageApi
                            .addNameAlias(addname_obj, this)
                            .then(() => {
                                this.senior_search();
                            })
                            .catch(() => {});
                    }
                } else if (typeof this.select_alias === "object") {
                    if (this.select_alias.id == row.useAliasId) return;
                    //选择了与之前一样的，不做处理
                    else {
                        ////////修改选择的别名/////////
                        let param = new Object();
                        param.id = row.id;
                        param.anotherNameId = this.select_alias.id;
                        buyPageApi
                            .updateNameAlias(param, this)
                            .then(() => {
                                this.senior_search();
                            })
                            .catch(() => {});
                    }
                }
                this.select_alias = "";
            }
            // this.send_update(row)
        },
        alias_blur(row, column) {
            if (column.property == "nameAlias") {
                setTimeout(() => {
                    row.alias_show = false;
                }, 100);
            }
        },
        //从ERP拉取同步采购订单
        pull_reflesh() {
            this.flag = true;
            buyPageApi
                .updateErpPurForm(this)
                .then(() => {
                    this.senior_search();
                    this.flag = false;
                })
                .catch(() => {});
        },
        expExcel() {
            if (this.table_data.length == 0) {
                this.$alert("表格无数据", "异常导出", { type: "warning" });
                return;
            }
            let titleList = ["订单号", "需用日期", "物料名称", "规格型号", "物料编码", "备注", "数量", "单价", "金额"];
            let rows = [];
            this.table_data.forEach((item, index) => {
                let tem = [item.formId, item.useDate, item.materialName, item.materialType, item.materialBarcode, item.itemRemark, item.buyNumber, item.price, item.totalPrice];
                rows.push(tem);
            });
            console.log(rows);
            exportExcel2(titleList, rows, `采购订单${this.$getTime()}.xlsx`);
        },
    },
    mounted() {
        this.showTime();
    },
    created() {
        // 总览页通过 formId 路由参数定位采购订单明细
        let routeFormId = this.$route.query.formId;
        if (routeFormId !== null && routeFormId !== undefined) {
            this.searchobj.formId = String(routeFormId).trim();
        }
        this.senior_search();
    },
};
</script>
<style>
.home {
    height: 100%;
}

.el-header {
    background-color: #12b4bd;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover > td {
    background-color: #c0ddaf !important;
}

.table-body .selected-row {
    background-color: #c0ddaf;
}

.table-body .el-table__body tr {
    cursor: pointer;
}

.nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
    /* 使用transform缩放选择框 */
}

/* .table-body .el-table__body-wrapper::-webkit-scrollbar { */
/* width: 5px !important; */
/* height: 5px !important; */
/* } */
.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    /* z-index: 999 !important; */
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}

.home .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
}

.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}

.el-input--mini {
    font-size: 14px !important;
}
</style>
<style scoped>
.buy-overview {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f2f3f5;
    font-family: "sonti", "Arial";
}
.overview-header {
    height: 52px !important;
    flex: 0 0 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #0faeb8 0%, #12b4bd 55%, #28c1c8 100%);
    box-shadow: 0 2px 10px rgba(18, 180, 189, 0.2);
}

.header-left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}
.header-left img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.header-text-left {
    flex-shrink: 0;
    font-size: 21px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 1px;
    color: #fff;
}

.pe-header-text {
    min-width: 0;
    margin-left: 6px;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.38);
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-info {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 2px;
}

.header-right {
    line-height: 18px;
    font-size: 12px;
    text-align: right;
    color: rgba(255, 255, 255, 0.92);
}

.el-form-item {
    margin-bottom: 12px;
}

.table-body {
    /* height: calc(100% - 52px); */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.toolbar {
    background-color: #fff;
    padding: 10px 15px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.toolbar .el-button {
    transition: all 0.2s ease;
}

.toolbar .el-button:hover {
    transform: translateY(-2px);
}

.dialog-height::v-deep .el-table__body-wrapper {
    max-height: 65vh !important;
    overflow: scroll;
    padding-top: 0px;
}

.dialog-height::v-deep .el-dialog__body {
    padding: 20px !important;
}

@media screen and (max-width: 900px) {
    .overview-header {
        padding: 0 12px;
    }

    .header-text-left {
        font-size: 18px;
    }

    .pe-header-text {
        margin-left: 2px;
        padding-left: 10px;
        font-size: 14px;
    }

    .header-info {
        margin-left: 12px;
    }
}

@media screen and (max-width: 640px) {
    .overview-header {
        height: 48px !important;
        flex-basis: 48px;
    }

    .header-left img {
        width: 30px;
        height: 30px;
    }

    .header-text-left {
        font-size: 16px;
        letter-spacing: 0;
    }

    .pe-header-text {
        display: none;
    }

    .header-info .header-right:first-child {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .header-info .header-right:last-child {
        display: none;
    }
}
</style>
